// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import Header from "../../component/_elements/Header.tsx";
import General from "./General.tsx";
import { OutletContextType } from "../../types/GlobalType";
import Scolarite from "./Scolarite.tsx";
import Student from "./Student.tsx";
import Personal from "./Personal.tsx";
import Parent from "./Parent.tsx";
import User from "./User.tsx";
import Role from "./Role.tsx";
import HasRole from "../../component/_elements/HasRole.tsx";

// skeleton for setting
const ParametresSkeleton = ({ isDarkMode }: { isDarkMode: boolean }) => {
  return (
    <div className="animate-pulse">
      {/* Page title */}
      <div className="ml-6 mt-24">
        <div className="h-7 w-40 mb-2 rounded bg-gray-300 dark:bg-gray-700"></div>
        <div className="h-4 w-96 rounded bg-gray-300 dark:bg-gray-700"></div>
      </div>

      {/* Tabs skeleton */}

      <div className="flex flex-wrap gap-2 mt-5 mb-4 ml-6">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className={`h-5 w-30 lg:h-5 lg:w-40 rounded-md ${
              isDarkMode ? "bg-gray-700" : "bg-gray-300"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
};

const Parametre: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("general");
  // const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  // const [isNewFeeModalOpen, setIsNewFeeModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  // const [selectedImage, setSelectedImage] = useState<string | null>(null);
  // const [showCropModal, setShowCropModal] = useState(false);
  // const [currentStep, setCurrentStep] = useState(1);
  // const [uploadSuccess, setUploadSuccess] = useState(false);
  // const [activeFormTab, setActiveFormTab] = useState("personal");
  // const [selectedItem, setSelectedItem] = useState<any>(null);
  // const [showViewModal, setShowViewModal] = useState(false);
  // const [activeViewTab, setActiveViewTab] = useState("personal");

  // const [newFeeForm, setNewFeeForm] = useState({
  //   name: "",
  //   description: "",
  //   defaultAmount: "",
  //   frequency: "monthly",
  //   isRequired: false,
  // });

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [itemToDelete, setItemToDelete] = useState(null);
  // const [deleteConfirmed, setDeleteConfirmed] = useState(false);
  // const [isNewUserModalOpen, setIsNewUserModalOpen] = useState(false);
  // const [isNewRoleModalOpen, setIsNewRoleModalOpen] = useState(false);
  // const [newUserForm, setNewUserForm] = useState({
  //   firstName: "",
  //   lastName: "",
  //   email: "",
  //   role: "enseignant",
  //   password: "",
  //   confirmPassword: "",
  //   isActive: true,
  // });

  const [studentFilter, setStudentFilter] = useState({
    schoolYear: "2025 - 2026",
    status: "all",
    isYearDropdownOpen: false,
    isStatusDropdownOpen: false,
    currentPage: 1,
    itemsPerPage: 10,
  });

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const yearFilterBtn = document.getElementById("yearFilterBtn");
      const statusFilterBtn = document.getElementById("statusFilterBtn");
      if (yearFilterBtn && !yearFilterBtn.contains(event.target as Node)) {
        setStudentFilter((prev) => ({
          ...prev,
          isYearDropdownOpen: false,
        }));
      }
      if (statusFilterBtn && !statusFilterBtn.contains(event.target as Node)) {
        setStudentFilter((prev) => ({
          ...prev,
          isStatusDropdownOpen: false,
        }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };

  const [triggerSkeleton, setTriggerSkeleton] = useState(true);
  setTimeout(() => {
    setTriggerSkeleton(false);
  }, 1000);

  return (
    <div className="md:ml-60 md:w-[calc(100%-15rem)]">
      {/* Header */}
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />
      {/* Settings Content */}

      {triggerSkeleton ? (
        <ParametresSkeleton isDarkMode={isDarkMode} />
      ) : (
        <main className="ml-20 md:ml-0 p-6 mt-16">
          <div className="mb-6 flex flex-col justify-start gap-4 lg:flex-row lg:justify-between lg:items-center">
            <div className="flex items-center gap-3">
              <div
                className={`h-9 w-9 flex items-center justify-center rounded-lg ${
                  isDarkMode
                    ? "bg-blue-500/10 text-blue-400"
                    : "bg-blue-50 text-blue-600"
                }`}
              >
                <i className="fas fa-cash-register text-sm"></i>
              </div>
              <div>
                <h1 className="text-md font-medium leading-tight">
                  Paramètres
                </h1>
                <p
                  className={`text-xs ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Gérez les paramètres de l'application
                </p>
              </div>
            </div>
            {/* <div className="flex gap-3"></div> */}
          </div>

          {/* Tabs */}
          <div className=" border-b border-gray-700">
            <div className="flex flex-wrap">
              <button
                onClick={() => setActiveTab("general")}
                className={`mr-2 inline-block pb-2 px-4 border-b-2  font-medium text-xs cursor-pointer whitespace-nowrap !rounded-button ${
                  activeTab === "general"
                    ? `${
                        isDarkMode
                          ? "border-blue-500 text-blue-500 "
                          : "border-blue-500 text-blue-600"
                      }`
                    : `${
                        isDarkMode
                          ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`
                }`}
              >
                <i className="fas fa-cog mr-2"></i>Général
              </button>
              <button
                onClick={() => setActiveTab("scolarite")}
                className={`mr-2 inline-block pb-2 px-4 border-b-2 font-medium text-xs cursor-pointer whitespace-nowrap !rounded-button ${
                  activeTab === "scolarite"
                    ? `${
                        isDarkMode
                          ? "border-blue-500 text-blue-500"
                          : "border-blue-500 text-blue-600"
                      }`
                    : `${
                        isDarkMode
                          ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`
                }`}
              >
                <i className="fas fa-graduation-cap mr-2"></i>Scolarité
              </button>
              <HasRole allowedRoles={["SuperAdministrateur", "Administrateur"]}>
                <button
                  onClick={() => setActiveTab("eleves")}
                  className={`mr-2 inline-block pb-2 px-4 border-b-2 font-medium text-xs cursor-pointer whitespace-nowrap !rounded-button ${
                    activeTab === "eleves"
                      ? `border-b-2 ${
                          isDarkMode
                            ? "border-blue-500 text-blue-500"
                            : "border-blue-600 text-blue-600"
                        }`
                      : `${
                          isDarkMode
                            ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`
                  }
            `}
                >
                  <i className="fas fa-user-graduate mr-2"></i>Élèves
                </button>
              </HasRole>
              <HasRole allowedRoles={["SuperAdministrateur", "Administrateur"]}>
                <button
                  onClick={() => setActiveTab("personnel")}
                  className={`mr-2 inline-block pb-2 px-4 border-b-2 font-medium text-xs cursor-pointer whitespace-nowrap !rounded-button ${
                    activeTab === "personnel"
                      ? `border-b-2 ${
                          isDarkMode
                            ? "border-blue-500 text-blue-500"
                            : "border-blue-600 text-blue-600"
                        }`
                      : `${
                          isDarkMode
                            ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`
                  }
              `}
                >
                  <i className="fas fa-users-cog mr-2"></i>Personnel
                </button>
              </HasRole>
              <button
                onClick={() => setActiveTab("parents")}
                className={`mr-2 inline-block pb-2 px-4 border-b-2 font-medium text-xs cursor-pointer whitespace-nowrap !rounded-button ${
                  activeTab === "parents"
                    ? `border-b-2 ${
                        isDarkMode
                          ? "border-blue-500 text-blue-500"
                          : "border-blue-600 text-blue-600"
                      }`
                    : `${
                        isDarkMode
                          ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`
                }
                 `}
              >
                <i className="fas fa-users mr-2"></i>Parents
              </button>
              <HasRole allowedRoles={["SuperAdministrateur", "Administrateur"]}>
                <button
                  onClick={() => setActiveTab("users")}
                  className={`mr-2 inline-block pb-2 px-4 border-b-2 font-medium text-xs cursor-pointer whitespace-nowrap !rounded-button ${
                    activeTab === "users"
                      ? `${
                          isDarkMode
                            ? "border-blue-500 text-blue-500"
                            : "border-blue-500 text-blue-600"
                        }`
                      : `${
                          isDarkMode
                            ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`
                  }`}
                >
                  <i className="fas fa-users mr-2"></i>Utilisateurs
                </button>
              </HasRole>
              <HasRole allowedRoles={["SuperAdministrateur"]}>
                <button
                  onClick={() => setActiveTab("roles")}
                  className={`mr-2 inline-block py-3 px-4 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap !rounded-button ${
                    activeTab === "roles"
                      ? `${
                          isDarkMode
                            ? "border-blue-500 text-blue-500"
                            : "border-blue-500 text-blue-600"
                        }`
                      : `${
                          isDarkMode
                            ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`
                  }`}
                >
                  <i className="fas fa-user-shield mr-2"></i>Rôles
                </button>
              </HasRole>
            </div>
          </div>
        </main>
      )}

      {/* Tab Content */}
      <div
        className={`${
          isDarkMode ? "bg-[#161B22]" : "bg-white"
        } rounded-lg p-6 border ${
          isDarkMode ? "border-gray-700" : "border-gray-300"
        }`}
      >
        {/* General Settings */}
        {activeTab === "general" && <General />}
        {/* Scolarité Settings */}
        {activeTab === "scolarite" && <Scolarite />}
        {/* Eleve Tab Content */}
        {activeTab === "eleves" && <Student />}
        {/* Personal Settings */}
        {activeTab === "personnel" && <Personal />}
        {/* Parents Settings */}

        {activeTab === "parents" && <Parent />}
        {/* Users Settings */}
        {activeTab === "users" && <User />}
        {/* Roles Settings */}
        {activeTab === "roles" && <Role />}
      </div>
    </div>
  );
};
export default Parametre;
